module.exports = __webpack_public_path__ + "img/picture_09.c3825a42.png";